<template>
    <article>
        <h2 is="sui-header">Choix du proxy</h2>
        <sui-dropdown
            placeholder="proxy"
            selection
            :options="options"
            v-model="activeGateway.configuration.proxyCode"
        />
    </article>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { api } from '@/api';

    const alphabeticalOrder = (a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0;

    const toSelectorOption = ({ code, name}) => ({ text: name, value: code });

    export default {
        name: 'ProxySelector',
        props: {
            proxy: { type: String },
        },
        data () {
            return {
                options: [],
            }
        },
        async created () {
            const proxies = await api.gateways.getAllProxies();
            const options = proxies.map(toSelectorOption).sort(alphabeticalOrder);
            this.options = options;
            if (!this.proxy && options.length) {
                this.activeGateway.configuration.proxyCode = options[0].value;
            }
        },
        computed: {
            ...mapGetters(['activeGateway']),
        }
    }
</script>
